module.exports = require('./helpers/bundle-url').getBundleURL('gvXu3') + "logo-dark.eefe0b7f.svg";